/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';

const LoadingWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #ffffffba;
	display: fixed;
	justify-content: center;
	align-items: center;
`;

const LoadingSpinner = styled.div`
	color: #439DD5;
	text-indent: -9999em;
	margin: 88px auto;
	position: relative;
	font-size: 11px;
	transform: translateZ(0);

	&,
	&:before,
	&:after {
	  background: #439DD5;
	  animation: load1 1s infinite ease-in-out -.16s;
	  width: 1em;
	  height: 4em;
	}

	&:before,
	&:after {
	  position: absolute;
	  top: 0;
	  content: '';
	}

	&:before {
	  left: -1.5em;
	  animation-delay: -0.32s;
	}

	&:after {
	  left: 1.5em;
	  animation-delay: -0s;
	}

	@keyframes load1 {
	  0%,
	  80%,
	  100% {
	    box-shadow: 0 0;
	    height: 4em;
	  }
	  40% {
	    box-shadow: 0 -2em;
	    height: 5em;
	  }
	}

`;

const LoadingIndicator = () => (
    <LoadingWrapper>
        <LoadingSpinner/>
    </LoadingWrapper>
);

export default LoadingIndicator;


// WEBPACK FOOTER //
// ./src/components/loading-indicator/index.js